import {
  Announcement,
  AnnouncementsFetchArgs,
  getAnnouncements,
} from '../assets/ts/data/announcements'
import useServerData from './use-server-data'

function useAnnouncements(
  fetchArgs: AnnouncementsFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: AnnouncementData,
    error: AnnouncementDataError,
    fetchData: fetchAnnouncementData,
    isLoading: AnnouncementDataIsLoading,
  } = useServerData<Announcement, AnnouncementsFetchArgs>(
    getAnnouncements,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    AnnouncementData,
    AnnouncementDataError,
    AnnouncementDataIsLoading,
    fetchAnnouncementData,
  }
}

export default useAnnouncements
